import { render, staticRenderFns } from "./c-button.vue?vue&type=template&id=6dbb0b00&"
import script from "./c-button.vue?vue&type=script&lang=js&"
export * from "./c-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports